import { api } from "@/lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getRegionQueryOptions, getRegionsQueryOptions } from "./get.hooks";

export function useDeleteRegion(opts?: {
  onSuccess?: () => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (id: string) =>
      api.delete<void>(`/api/regions/$id`, undefined, {
        pathReplace: { $id: id },
      }),
    onSuccess: (_, id) => {
      queryClient.setQueryData(getRegionsQueryOptions.queryKey, (old) =>
        old?.filter((r) => r.id !== id),
      );
      queryClient.resetQueries({
        queryKey: getRegionQueryOptions(id).queryKey,
      });
      toast({
        title: "toast.regionDeleted",
        variant: "success",
      });
      opts?.onSuccess?.();
    },
    onError: () => {
      toast({
        title: "toast.deleteRegionError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
